import { ReactNode } from 'react'

interface SectionBannerProps {
  title: string
  subtitle?: string
  children?: ReactNode
  size?: 'lg' | 'sm'
}

const SectionBanner = ({ title, subtitle, children, size = 'lg' }: SectionBannerProps) => {
  const padCls = size === 'lg' ? 'pt-6 pb-12' : 'pt-4 pb-8'
  const titleCls = size === 'lg' ? 'text-2xl font-bold' : 'text-xl font-bold'
  return (
    <div className={`bg-[#eefaef] px-4 ${padCls} relative overflow-hidden`}>
      <div className="absolute right-[-30px] top-[-20px] w-32 h-32 rounded-full bg-[#e0f5e2] opacity-60 animate-soft-pulse" />
      <div className="absolute right-12 top-8 w-16 h-16 rounded-full bg-[#d4edda] opacity-40 animate-soft-pulse" style={{ animationDelay: '1s' }} />
      <div className="relative z-10">
        <h2 className={`${titleCls} text-gray-800`}>{title}</h2>
        {subtitle && <p className={`text-gray-500 mt-1 ${size === 'lg' ? 'text-sm' : 'text-xs'}`}>{subtitle}</p>}
        {children && <div className="mt-3">{children}</div>}
      </div>
    </div>
  )
}

export default SectionBanner
